<template>
  <aside
    class="sidebar sidebar-adminEFP"
    :class="{ 'is-open': isSidebarOpen, 'is-collapsed': isSidebarCollapsed }"
  >
    <nav tabindex="-1" id="sidebarMenu" aria-labelledby="sidebarMenuLabel">
      <div class="sidebar-header sidebar-header-adminEFP">
        <router-link :to="adminEfp.firstAccessiblePath()" class="sidebar-logo">
          <img src="@/assets/images/efashion-blanc.png" alt="Logo Efashion" />
        </router-link>
        <button
          @click="toggleSidebar"
          class="sidebar-close-btn"
          aria-label="Fermer le menu"
        >
          <span>&times;</span>
        </button>
      </div>

      <!-- Admin connecté (impersonation, cookie HttpOnly) -->
      <div
        v-if="
          authStore.isImpersonating &&
          authStore.impersonationDisplayName &&
          !isSidebarCollapsed
        "
        class="sidebar-adminEFP-badge"
      >
        ADMIN : {{ authStore.impersonationDisplayName }}
      </div>

      <!-- Contenu normal de la sidebar -->
      <div class="sidebar-content" v-show="!isSidebarCollapsed">
        <div class="sidebar-nav">
          <ul>
            <li v-if="adminEfp.canAccess('dashboard')">
              <router-link to="/adminEFP/dashboard">
                <i class="fas fa-chart-pie"></i>
                Tableau de bord
              </router-link>
            </li>

            <li v-if="adminEfp.canAccess('statistiques')">
              <router-link to="/adminEFP/statistiques">
                <i class="fas fa-chart-bar"></i>
                Statistiques
              </router-link>
            </li>

            <!-- Clients -->
            <li v-if="canSeeClients">
              <span
                class="sidebar-collapse-trigger"
                @click="toggleCollapse('clients')"
                :aria-expanded="isCollapseOpen.clients"
                aria-controls="collapseClientsMenu"
              >
                <span><i class="fas fa-users"></i>Clients</span>
                <i class="chevron fas fa-chevron-right"></i>
              </span>
              <div
                class="sidebar-collapse-content"
                id="collapseClientsMenu"
                :class="isCollapseOpen.clients ? 'is-open' : 'is-closed'"
              >
                <ul>
                  <li v-if="adminEfp.canAccess('clients')">
                    <router-link to="/adminEFP/nouveaux-comptes"
                      >Gestion des clients</router-link
                    >
                  </li>
                  <li v-if="adminEfp.canAccess('clients')">
                    <router-link to="/adminEFP/acheteur-statement"
                      >Extraits de compte acheteurs</router-link
                    >
                  </li>
                  <li v-if="adminEfp.canAccess('top-acheteurs')">
                    <router-link to="/adminEFP/top-acheteurs"
                      >Top Acheteur</router-link
                    >
                  </li>
                  <li v-if="adminEfp.canAccess('nouveaux-acheteurs')">
                    <router-link to="/adminEFP/nouveaux-acheteurs"
                      >Nouveaux acheteurs</router-link
                    >
                  </li>
                  <li v-if="adminEfp.canAccess('grossistes-a-recontacter')">
                    <router-link to="/adminEFP/grossistes-a-recontacter"
                      >Grossistes à recontacter</router-link
                    >
                  </li>
                  <li v-if="adminEfp.canAccess('code-promos')">
                    <router-link to="/adminEFP/code-promos"
                      >Codes promos</router-link
                    >
                  </li>
                </ul>
              </div>
            </li>

            <!-- Commandes -->
            <li v-if="canSeeOrders">
              <span
                class="sidebar-collapse-trigger"
                @click="toggleCollapse('orders')"
                :aria-expanded="isCollapseOpen.orders"
                aria-controls="collapseOrdersMenu"
              >
                <span><i class="fas fa-clipboard-list"></i>Commandes</span>
                <i class="chevron fas fa-chevron-right"></i>
              </span>
              <div
                class="sidebar-collapse-content"
                id="collapseOrdersMenu"
                :class="isCollapseOpen.orders ? 'is-open' : 'is-closed'"
              >
                <ul>
                  <li v-if="adminEfp.canAccess('orders')">
                    <router-link to="/adminEFP/orders"
                      >Commandes Efashion</router-link
                    >
                  </li>
                  <li v-if="adminEfp.canAccess('orders')">
                    <router-link to="/adminEFP/orders/store"
                      >Commandes Store</router-link
                    >
                  </li>
                  <li v-if="adminEfp.canAccess('groupages')">
                    <router-link to="/adminEFP/groupages"
                      >Gestion des groupages</router-link
                    >
                  </li>
                  <li v-if="adminEfp.canAccess('ruptures')">
                    <router-link to="/adminEFP/commandes-rupture"
                      >Tableau des ruptures</router-link
                    >
                  </li>
                  <li v-if="adminEfp.canAccess('litige-retour')">
                    <router-link to="/adminEFP/litige-retour"
                      >Litige &amp; retour</router-link
                    >
                  </li>
                </ul>
              </div>
            </li>

            <!-- Facturation -->
            <li v-if="canSeeBilling">
              <span
                class="sidebar-collapse-trigger"
                @click="toggleCollapse('billing')"
                :aria-expanded="isCollapseOpen.billing"
                aria-controls="collapseBillingMenu"
              >
                <span><i class="fas fa-file-invoice-dollar"></i>Facturation</span>
                <i class="chevron fas fa-chevron-right"></i>
              </span>
              <div
                class="sidebar-collapse-content"
                id="collapseBillingMenu"
                :class="isCollapseOpen.billing ? 'is-open' : 'is-closed'"
              >
                <ul>
                  <li v-if="adminEfp.canAccess('facturation')">
                    <router-link to="/adminEFP/facturation"
                      >Facturation</router-link
                    >
                  </li>
                  <li v-if="adminEfp.canAccess('vendeur-facturation')">
                    <router-link to="/adminEFP/vendeur-facturation"
                      >Facturation vendeurs</router-link
                    >
                  </li>
                </ul>
              </div>
            </li>

            <!-- Contenu -->
            <li v-if="canSeeContent">
              <span
                class="sidebar-collapse-trigger"
                @click="toggleCollapse('content')"
                :aria-expanded="isCollapseOpen.content"
                aria-controls="collapseContentMenu"
              >
                <span><i class="fas fa-newspaper"></i>Contenu</span>
                <i class="chevron fas fa-chevron-right"></i>
              </span>
              <div
                class="sidebar-collapse-content"
                id="collapseContentMenu"
                :class="isCollapseOpen.content ? 'is-open' : 'is-closed'"
              >
                <ul>
                  <li v-if="adminEfp.canAccess('actualites')">
                    <router-link to="/adminEFP/actualites"
                      >Actualités</router-link
                    >
                  </li>
                  <li v-if="adminEfp.canAccess('couleurs')">
                    <router-link to="/adminEFP/couleurs"
                      >Couleurs officielles</router-link
                    >
                  </li>
                  <li v-if="adminEfp.canAccess('mel-template')">
                    <router-link to="/adminEFP/mel-template"
                      >Données template MEL</router-link
                    >
                  </li>
                  <li v-if="adminEfp.canAccess('cms')">
                    <router-link to="/adminEFP/store-prestations"
                      >Prestations Store</router-link
                    >
                  </li>
                  <li v-if="adminEfp.canAccess('cms')">
                    <router-link to="/adminEFP/cms/pages">Pages</router-link>
                  </li>
                  <li v-if="adminEfp.canAccess('cms')">
                    <router-link to="/adminEFP/cms/widgets">Widgets</router-link>
                  </li>
                  <li v-if="adminEfp.canAccess('cms')">
                    <router-link to="/adminEFP/cms/media">Médiathèque</router-link>
                  </li>
                </ul>
              </div>
            </li>

            <!-- Shooting -->
            <li v-if="adminEfp.canAccess('shooting')">
              <span
                class="sidebar-collapse-trigger"
                @click="toggleCollapse('shooting')"
                :aria-expanded="isCollapseOpen.shooting"
                aria-controls="collapseShootingMenu"
              >
                <span><i class="fas fa-camera"></i>Shooting</span>
                <i class="chevron fas fa-chevron-right"></i>
              </span>
              <div
                class="sidebar-collapse-content"
                id="collapseShootingMenu"
                :class="isCollapseOpen.shooting ? 'is-open' : 'is-closed'"
              >
                <ul>
                  <li>
                    <router-link
                      :to="{ name: 'list-modeles' }"
                      active-class=""
                      exact-active-class="router-link-exact-active"
                      >Gestion des modèles</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{ name: 'pickup-return' }"
                      active-class=""
                      exact-active-class="router-link-exact-active"
                      >Pickup &amp; Return</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{ name: 'agenda-shooting' }"
                      active-class=""
                      exact-active-class="router-link-exact-active"
                      >Shooting Agenda</router-link
                    >
                  </li>
                  <li>
                    <router-link
                      :to="{ name: 'manager-shooting' }"
                      active-class=""
                      exact-active-class="router-link-exact-active"
                      >Manager Shooting</router-link
                    >
                  </li>
                </ul>
              </div>
            </li>

            <li v-if="adminEfp.isSuperAdmin || adminEfp.canAccess('shooting')">
              <router-link :to="{ name: 'adminEFP/shopify' }">
                <i class="fab fa-shopify"></i>
                Shopify
              </router-link>
            </li>

            <li v-if="adminEfp.isSuperAdmin" class="access-management-item">
              <router-link to="/adminEFP/logging">
                <i class="fas fa-clipboard-list"></i>
                Journal des actions
              </router-link>
            </li>

            <li v-if="adminEfp.isSuperAdmin">
              <router-link to="/adminEFP/access">
                <i class="fas fa-user-shield"></i>
                Gestion des accès
              </router-link>
            </li>
          </ul>
        </div>
      </div>

      <!-- Icônes flottantes pour la sidebar rétractée -->
      <div class="sidebar-collapsed-icons" v-show="isSidebarCollapsed">
        <div
          v-if="authStore.isImpersonating && authStore.impersonationDisplayName"
          class="sidebar-adminEFP-badge collapsed"
          :title="'ADMIN : ' + authStore.impersonationDisplayName"
        >
          ADMIN
        </div>
        <div
          class="collapsed-icon"
          @click="router.push('/')"
          title="Tableau de bord"
        >
          <i class="fas fa-home"></i>
        </div>
        <div
          class="collapsed-icon"
          @click="navigateTo('account/infos')"
          title="Informations générales"
        >
          <i class="fas fa-store"></i>
        </div>
      </div>
    </nav>
  </aside>
</template>

<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";
import { useAdminEfpStore } from "@/stores/adminEfp";
import type { AdminPermissionKey } from "@/config/adminPermissions";

const authStore = useAuthStore();
const adminEfp = useAdminEfpStore();

interface Props {
  isSidebarOpen: boolean;
  isSidebarCollapsed: boolean;
  vendeurData: any;
}

interface Emits {
  (e: "toggle-sidebar"): void;
}

type CollapseSection =
  | "clients"
  | "orders"
  | "billing"
  | "content"
  | "shooting";

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const router = useRouter();

const isCollapseOpen = ref<Record<CollapseSection, boolean>>({
  clients: false,
  orders: false,
  billing: false,
  content: false,
  shooting: false,
});

const canSeeClients = computed(
  () =>
    adminEfp.canAccess("clients") ||
    adminEfp.canAccess("top-acheteurs") ||
    adminEfp.canAccess("nouveaux-acheteurs") ||
    adminEfp.canAccess("grossistes-a-recontacter") ||
    adminEfp.canAccess("code-promos")
);

const canSeeOrders = computed(
  () =>
    adminEfp.canAccess("orders") ||
    adminEfp.canAccess("groupages") ||
    adminEfp.canAccess("ruptures") ||
    adminEfp.canAccess("litige-retour")
);

const canSeeBilling = computed(
  () =>
    adminEfp.canAccess("facturation") ||
    adminEfp.canAccess("vendeur-facturation")
);

const canSeeContent = computed(
  () =>
    adminEfp.canAccess("actualites") ||
    adminEfp.canAccess("mel-template") ||
    adminEfp.canAccess("cms") ||
    adminEfp.canAccess("couleurs")
);

const SECTION_PERMISSIONS: Record<CollapseSection, AdminPermissionKey[]> = {
  clients: [
    "clients",
    "top-acheteurs",
    "nouveaux-acheteurs",
    "grossistes-a-recontacter",
    "code-promos",
  ],
  orders: ["orders", "groupages", "ruptures", "litige-retour"],
  billing: ["facturation", "vendeur-facturation"],
  content: ["actualites", "mel-template", "cms", "couleurs"],
  shooting: ["shooting"],
};

const PATH_TO_SECTION: Array<{ prefix: string; section: CollapseSection }> = [
  { prefix: "/adminEFP/nouveaux-comptes", section: "clients" },
  { prefix: "/adminEFP/acheteur-statement", section: "clients" },
  { prefix: "/adminEFP/hipay", section: "clients" },
  { prefix: "/adminEFP/vendeur-fiche", section: "clients" },
  { prefix: "/adminEFP/top-acheteurs", section: "clients" },
  { prefix: "/adminEFP/nouveaux-acheteurs", section: "clients" },
  { prefix: "/adminEFP/grossistes-a-recontacter", section: "clients" },
  { prefix: "/adminEFP/code-promos", section: "clients" },
  { prefix: "/adminEFP/cms", section: "content" },
  { prefix: "/adminEFP/store-prestations", section: "content" },
  { prefix: "/adminEFP/orders", section: "orders" },
  { prefix: "/adminEFP/groupages", section: "orders" },
  { prefix: "/adminEFP/groupage-detail", section: "orders" },
  { prefix: "/adminEFP/commandes-rupture", section: "orders" },
  { prefix: "/adminEFP/litige-retour", section: "orders" },
  { prefix: "/adminEFP/facturation", section: "billing" },
  { prefix: "/adminEFP/vendeur-facturation", section: "billing" },
  { prefix: "/adminEFP/actualites", section: "content" },
  { prefix: "/adminEFP/couleurs", section: "content" },
  { prefix: "/adminEFP/mel-template", section: "content" },
  { prefix: "/adminEFP/shooting", section: "shooting" },
  { prefix: "/adminEFP/pickupreturn", section: "shooting" },
];

function sectionForPath(path: string): CollapseSection | null {
  for (const { prefix, section } of PATH_TO_SECTION) {
    if (path === prefix || path.startsWith(`${prefix}/`)) {
      return section;
    }
  }
  return null;
}

function openSection(section: CollapseSection) {
  Object.keys(isCollapseOpen.value).forEach((key) => {
    isCollapseOpen.value[key as CollapseSection] = false;
  });
  isCollapseOpen.value[section] = true;
}

const toggleSidebar = () => {
  emit("toggle-sidebar");
};

const toggleCollapse = (section: CollapseSection) => {
  if (isCollapseOpen.value[section]) {
    isCollapseOpen.value[section] = false;
  } else {
    openSection(section);
  }
};

const navigateTo = (routeName: string) => {
  router.push({ name: routeName });
};

const isMobile = () => window.matchMedia("(max-width: 768px)").matches;

watch(
  () => router.currentRoute.value.fullPath,
  (path) => {
    const section = sectionForPath(path);
    if (section) {
      const permissions = SECTION_PERMISSIONS[section];
      if (permissions.some((key) => adminEfp.canAccess(key))) {
        openSection(section);
      }
    }
    if (isMobile() && props.isSidebarOpen) {
      emit("toggle-sidebar");
    }
  },
  { immediate: true }
);
</script>

<style lang="scss" scoped>
.sidebar-adminEFP,
.sidebar-header-adminEFP {
  background-color: #004273 !important;
}

.sidebar-adminEFP-badge {
  margin: 0.5rem 0.75rem;
  padding: 0.35rem 0.6rem;
  font-size: 0.75rem;
  font-weight: 600;
  color: #4c1d95;
  background-color: #ede9fe;
  border-radius: 6px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  &.collapsed {
    margin: 0.25rem auto;
    padding: 0.25rem 0.4rem;
    text-align: center;
    max-width: 4rem;
  }
}

@media print {
  .sidebar {
    display: none !important;
  }
}

.access-management-item {
  margin-top: 0.75rem;
  padding-top: 0.75rem;
  border-top: 1px solid rgba(255, 255, 255, 0.16);
}
</style>
